import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=89307010&scoped=true"
import script from "./Inspections.vue?vue&type=script&lang=js"
export * from "./Inspections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89307010",
  null
  
)

export default component.exports